import React, { createContext } from 'react'
import PropTypes from 'prop-types'

export const StyleContext = createContext()
export const StyleProvider = ({ initialStyle, children }) => (
  <StyleContext.Provider value={initialStyle}>{children}</StyleContext.Provider>
)

StyleProvider.propTypes = {
  initialStyle: PropTypes.object.isRequired,
  children: PropTypes.any
}
